import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";
import {latLng, LocationServiceProvider} from "../location-service/location-service";

@Injectable()
export class SearchServiceProvider {

  constructor(
    public http: HttpClient,
    public locationService: LocationServiceProvider,
    public apiErrorHandler: ApiErrorHandlerProvider,
  ) {
  }

  search(shopName,cityId= 'All') {
    return new Promise((resolve, reject) => {
      this.locationService.geolocate().then((latLng: latLng) => {
        return latLng;
      }).then(latLng=>{

        let url = `/search/teams?shop=${shopName}&lat=${latLng.lat}&lng=${latLng.lng}&city=${cityId}`;

        this.http.get(url)
          .subscribe((shops: Array<any>) => {
            resolve(shops)
          }, error => {
            this.apiErrorHandler.handleError(error);
            reject(error)
          });

      }).catch(()=>{

        let url = `/search/teams?shop=${shopName}&city=${cityId}`;

        this.http.get(url)
          .subscribe((shops: Array<any>) => {
            resolve(shops)
          }, error => {
            this.apiErrorHandler.handleError(error);
            reject(error)
          });

      });

    });
  }
  topRated() {
    return new Promise((resolve, reject) => {
      this.locationService.geolocate().then((latLng: latLng) => {
        return latLng;
      }).then(latLng=>{
        let url = `/top/teams?lat=${latLng.lat}&lng=${latLng.lng}`;
        this.http.get(url)
          .subscribe((shops: Array<any>) => {
            resolve(shops)
          }, error => {
            this.apiErrorHandler.handleError(error);
            reject(error)
          });
      }).catch(()=>{
        let url = `/top/teams`;
        this.http.get(url)
          .subscribe((shops: Array<any>) => {
            resolve(shops)
          }, error => {
            this.apiErrorHandler.handleError(error);
            reject(error)
          });

      });
    });
  }

  getShopQueueTime(shop) {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${shop.id}/queue`)
        .subscribe((response: any) => {
          shop.queue = response;
        }, error => {
          this.apiErrorHandler.handleError(error);
          reject(error)
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/search-service/search-service.ts